import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_PROMOTE_OR_SHARE_CHANNEL_AWARE_CTA = defineFcm('psf_promote_or_share_channel_aware_cta')
	.asJson(
		createShapeNormalizer({
			type: 'array',
			shape: {
				type: 'enum',
				values: ['facebook', 'whatsapp'] as const,
			},
		}),
	)
	.withDefault([])
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'psf promote-or-share share slide-up',
		description:
			'Channel-aware PSF CTA (productized from CHANGE-97154): per-country list of arrival channels that get the prominent "Share to <channel>" primary CTA on the promote_or_share share slide-up, matched to the signer\'s current_medium. Empty = off. Facebook shipped 2026 (CHANGE-98150); WhatsApp follows once its experiment concludes (CHANGE-98145).',
		import: false,
		template: ['facebook'],
	});
